<template>
	<div class="card-body" ref="chatBody" id="chatBody">
		<div v-for="(mensaje, index) in mensajes" class="chat-container">
			<div v-if="validateSameDay(index, mensaje.FECHA_CREACION)" class="text-center mb-2">
				<span class="badge badge-secondary">{{mensaje.FECHA_CREACION | date}}</span>
			</div>
			<div v-bind:class="{'media mb-3':true, 'right':currentUser.CODIGO_USUARIO==mensaje.CREADO_POR, 'pl-5':!validateSameUser(index, mensaje.CREADO_POR)}">
				<div class="mr-3" v-if="currentUser.CODIGO_USUARIO!=mensaje.CREADO_POR && mensaje.usuario && validateSameUser(index, mensaje.CREADO_POR)">
					<img :src="mensaje.usuario.SEXO | imgUrl" class="rounded-circle" alt="Logo" width="30px" height="30px">
				</div>
				<div class="media-body">
					<div class="card shadow">
						<div class="card-body py-1">
					      	<div class="text-header" v-if="validateSameUser(index, mensaje.CREADO_POR)">
						      	<small class="text-muted" v-if="mensaje.usuario">
						      		{{mensaje.usuario.NOMBRE}}
						      	</small>
						      	<small v-else class="text-muted">
						      		{{mensaje.CREADO_POR}}
						      	</small>
					      	</div>

						    {{mensaje.TEXTO}} {{mensaje.TEXTO2}} {{mensaje.TEXTO3}}
						    <div class="text-right" :title="mensaje.FECHA_CREACION | hour">
						    	<small class="text-muted">{{mensaje.FECHA_CREACION | ago }}</small>
						    </div>
						</div>
					</div>
			  	</div>
			</div>
			<div v-if="showMoreMessage" class="more-messages">
				<span>Ver mensajes nuevos</span>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		props: ['mensajes', 'user'],

		data(){
			return {
				showMoreMessage: false
			}
		},

		methods: {
			bottomScroll:  function(){
				var vm = this
				vm.$nextTick(() => {
                	vm.$refs.chatBody.scrollTop = vm.$refs.chatBody.scrollHeight
                })
			},

			validateSameDay: function(index, fecha){
				if (index == 0) {
					return true
				}
				var fAnterior = this.mensajes[index-1].FECHA_CREACION
				return !moment(fecha).isSame(fAnterior, 'day')
			},

			validateSameUser: function(index, user){
				if (index == 0) {
					return true
				}

				return this.mensajes[index-1].CREADO_POR != user
			}
		},

		mounted(){
			let _this = this
			this.$refs.chatBody.addEventListener('scroll', function(){
				if (this.scrollTop === (this.scrollHeight - this.offsetHeight)) {
					_this.showMoreMessage = false
				}
			});
		},

		computed:{
			currentUser: function(){
				return this.user
			}
		},

		watch: {
			mensajes: function(val){
				this.showMoreMessage = false
			}
		},

		filters: {
			imgUrl: function(val){
				if (val == 'F') {
					return crm.url+'/images/icons/girl.png'
				}

				return crm.url+'/images/icons/boy.png'
			},

			hour(value){
            	return moment(value).format('hh:mm a')
            },

            date(value){
            	var date = moment(value)
            	if (moment().isSame(date, 'day')) {
            		return 'Hoy'
            	}

            	if (moment().subtract(1, 'days').isSame(date, 'day')) {
            		return 'Ayer'
            	}

            	if (moment().subtract(2, 'days').isSame(date, 'day')) {
            		return date.format('dddd')
            	}

            	if (moment().subtract(3, 'days').isSame(date, 'day')) {
            		return date.format('dddd')
            	}

            	if (moment().subtract(4, 'days').isSame(date, 'day')) {
            		return date.format('dddd')
            	}

            	if (moment().subtract(5, 'days').isSame(date, 'day')) {
            		return date.format('dddd')
            	}

            	return moment(value).format('DD/MM/YYYY')
            },

            ago(value){
            	return moment(value).fromNow()
            },
		}
	}
</script>
<style>
	.more-messages {
		position: sticky;
		bottom: 0px;
		background-color: rgba(0,0,0,0.3);
		text-align: center;
		color: white;
		padding: 5px;
		border-radius: 5px;
	}
</style>